import BaseView from '@/core/view/BaseView'

class AnchorLinks extends BaseView {
  //
  private commonFooter: HTMLElement

  // 要素
  private elem: HTMLElement

  // 初期位置
  private defaultPosition = 0

  //ビューの高さ
  private viewHeight = 0

  /**
   * コンストラクタ
   *
   */
  constructor(elem: HTMLElement) {
    super()

    this.elem = elem

    // デフォルト位置を記憶
    this.defaultPosition = parseInt(
      window.getComputedStyle(this.elem).top.replace('px', ''),
    )

    // ビューの高さ
    this.viewHeight = (this.elem.children[0] as HTMLElement).offsetHeight

    // フッター
    this.commonFooter = document.getElementsByClassName(
      'common-footer',
    )![0] as HTMLElement

    this.listenResize()
    this.listenScroll()
  }

  /**
   * リサイズイベントハンドラ
   *
   */
  public onResize(): void {
    this.onScroll()
  }

  /**
   * スクロールイベントハンドラ
   */
  onScroll(): void {
    // スクロール位置
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    // 画面高さ
    const windowHeight = document.documentElement.clientHeight

    const rect = this.commonFooter.getBoundingClientRect()

    // 押出の位置
    let yps = scrollTop + windowHeight
    yps -= windowHeight - this.defaultPosition - this.viewHeight

    // 押出量
    let offsetY = 0
    if (yps > this.commonFooter.offsetTop) {
      offsetY = yps - this.commonFooter.offsetTop
    }

    this.elem.style.marginTop = -1 * offsetY + 'px'
  }
}

export default AnchorLinks
